import React from 'react';
import Routes from './Routes';

const ManagerRoleRoutes = () => {
  return <Routes />;
};

export default ManagerRoleRoutes;
